var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconLogout(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 3C14.4477 3 14 3.44772 14 4C14 4.55228 14.4477 5 15 5H19V19H15C14.4477 19 14 19.4477 14 20C14 20.5523 14.4477 21 15 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H15ZM9.21914 7.37528C9.56415 6.94402 10.1934 6.8741 10.6247 7.21911L15.62 11.2153C15.6279 11.2216 15.6356 11.2279 15.6433 11.2343C15.6909 11.2743 15.7343 11.3184 15.7732 11.3657C15.9096 11.5318 15.9935 11.7426 15.9996 11.9729C15.9999 11.9819 16 11.9909 16 12L15.9997 12.0236C15.9926 12.3338 15.8441 12.6091 15.6162 12.7877L10.6247 16.7808C10.1934 17.1259 9.56415 17.0559 9.21914 16.6247C8.87413 16.1934 8.94405 15.5641 9.37531 15.2191L12.1492 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H12.1493L9.37531 8.78084C8.94405 8.43583 8.87413 7.80654 9.21914 7.37528Z", fill: color })));
}
//# sourceMappingURL=icon.logout.component.js.map